module.exports = __webpack_public_path__ + "static/media/testimonial_3.01a9edcc.jpg";